import { DataModel } from "@essenza/core";

export function JobModel() {
  DataModel.call(this, "joboffer");

  this.Approve = () => {
    this.ExecuteQuery(`approve: [joboffer]  (istatus=0){*,
        #join: users (id=idcompany) {tbusinessname, tsite}, -O id -D
      }`);
  };

  this.Approved = () => {
    this.ExecuteApi(`approved: [joboffer] {*}`);
  };

  this.Active = (userid) => {
    this.ExecuteApi(`active: [joboffer] {*}`);
  };

  this.Close = () => {
    this.ExecuteApi(`close: [joboffer] {*}`);
  };
}

export function CandidateModel() {
  DataModel.call(this, "users");

  this.all = () => {
    //this.list("itype=2");
    this.ExecuteApi(`all: [users] {*}`);
  };

  this.candidates = (idjob) => {
    this.ExecuteApi(`candidates: [users] {*}`, { idjob: idjob });
  };

}